<template>
  <div v-if="recommendIsLoad && recommendData.length > 0" class="other-recommend">
    <span class="other-recommend-title">專屬您的推薦商品</span>
    <Carousel :items-to-show="2" :snap-align="'start'" :breakpoints="breakpoints">
      <Slide v-for="r in recommendData" :key="r.MarketID">
        <div class="product-box">
          <a :href="r.Colors[0].MarketUrl">
            <NewImage :url="r.Colors[0].Covers[0]" :size="'_w460_h644'" :name="r.Name" />
            <div class="item-info">
              <div class="product-name">{{ r.Name }}</div>
              <div class="product-price">
                <span v-if="r.EventPrice > 0 || r.SellPrice !== r.OriginPrice" class="origin-price">
                  NT.{{ r.OriginPrice }}
                </span>
                <span class="sell-price">
                  NT.{{
                    r.EventPrice > 0 && r.EventPrice < r.SellPrice ? r.EventPrice : r.SellPrice
                  }}
                </span>
              </div>
            </div>
          </a>
        </div>
      </Slide>

      <template #addons>
        <Navigation>
          <template #next>
            <a class="arrow" @click="fireGAEvent('next')">
              <img
                class="img-fluid"
                src="https://static.tpx.tw/sff/thebutters/static/img/arrow-right.svg"
              />
            </a>
          </template>
          <template #prev>
            <a class="arrow" @click="fireGAEvent('previous')">
              <img
                class="img-fluid"
                src="https://static.tpx.tw/sff/thebutters/static/img/arrow-left.svg"
              />
            </a>
          </template>
        </Navigation>
      </template>
    </Carousel>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Carousel, Navigation, Slide } from 'vue3-carousel';

import { storeToRefs } from 'pinia';
import useShopContentStore from '@global/stores/useShopContentStore';

import { fireRecommendClickGAEvent, fireRecommendViewGAEvent } from '@global/gtm/product';

import NewImage from '@global/components/common/Image/NewImage.vue';

const shopContentStore = useShopContentStore();
const { recommendData, recommendIsLoad, selectedFoodSpec, itemDatas } =
  storeToRefs(shopContentStore);

const breakpoints = ref({
  768: {
    itemsToShow: 3,
    snapAlign: 'start',
  },
});

watch(recommendIsLoad, (val) => {
  if (val && recommendData.value.length) {
    fireRecommendViewGAEvent({
      itemListName: `${window.CustomMarketID.split('SZ')[0]} 用戶推薦產品列表`,
      recommendData: recommendData.value,
    });
  }
});

function fireGAEvent(direction) {
  fireRecommendClickGAEvent({
    recommendedType: '產品內頁',
    recommendedMove: direction === 'previous' ? '推薦商品 More 左箭頭' : '推薦商品 More 右箭頭',
    itemListName: '用戶推薦產品列表',
    recommendedData: recommendData.value,
    productId: window.CustomMarketID,
    productName: window.Pattern === 2 ? selectedFoodSpec.value.Product?.Name : itemDatas.value.Name,
  });
}
</script>
